import { useParams } from 'react-router-dom';
import StudentProfileEditor from 'components/student-profile/StudentProfileEditor';

// Mismo editor que asesoras (components/student-profile) para que ambos vean
// y guarden los mismos datos de la ficha de matrícula.
export default function ModifyStudentAdmin() {
  const { id } = useParams();
  return <StudentProfileEditor studentId={id} backTo={`/plataforma/administrador/ver-estudiante/${id}`} />;
}
